import { valibotResolver } from "@hookform/resolvers/valibot";
import { PencilSimpleLine } from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import { TemplateNameSchema } from "features/templates/schemas";

import RestrictedComponent from "common/components/RestrictedComponent";
import { Button } from "common/components/ui/Button";
import { Input } from "common/components/ui/Input";

import useTemplateMutations from "../../../../datahooks/useTemplateMutations";

export default function EditableTemplateName({
  templateName,
  templateId,
}: {
  templateName: string;
  templateId: string;
}) {
  const { updateTemplate, isUpdatingTemplate } = useTemplateMutations();
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: { name: templateName },
    resolver: valibotResolver(TemplateNameSchema),
  });

  useEffect(() => {
    reset({ name: templateName });
  }, [templateName]);

  const [isEditing, setIsEditing] = useState(false);

  function onSubmit({ name }: { name: string }) {
    updateTemplate({ templateId, updates: { name } }).then(() => {
      setIsEditing(false);
      reset({ name });
    });
  }

  if (isEditing) {
    return (
      <div className="mb-0.5 flex items-center">
        <Input
          variant="sm"
          className="lg:w-72"
          hasError={!!errors.name?.message}
          autoFocus
          {...register("name")}
        />
        <Button
          size="sm"
          className="ml-3 mr-2"
          variant="secondary-black"
          disabled={isUpdatingTemplate}
          onClick={() => {
            setIsEditing(false);
            reset({ name: templateName });
          }}
        >
          Cancel
        </Button>
        <Button
          size="sm"
          onClick={handleSubmit(onSubmit)}
          isLoading={isUpdatingTemplate}
        >
          Save
        </Button>
      </div>
    );
  }
  return (
    <div className="mb-0.5 flex items-center gap-x-1 py-0.5 pl-2">
      <span className="text-md-bold">{templateName}</span>
      <RestrictedComponent visibleFor={["templates_full"]}>
        <Button
          variant="ghost-black"
          size="xs"
          intent="iconOnly"
          onClick={() => setIsEditing(true)}
        >
          <PencilSimpleLine />
        </Button>
      </RestrictedComponent>
    </div>
  );
}
